import { Spin, Typography } from 'antd'

import { formatFileSize } from './attachments'
import type { ChatAttachment } from './attachments'
import { ChatAttachmentIcon } from './ChatAttachmentIcon'
import { useStyles } from './styles'

const { Text } = Typography

type Props = {
  attachment: ChatAttachment
  busy: boolean
  onOpen: () => void
}

export const ChatAttachmentCard = ({ attachment, busy, onOpen }: Props) => {
  const { styles } = useStyles()

  return (
    <button
      type="button"
      className={styles.attachmentTile}
      aria-busy={busy}
      onClick={() => {
        if (!busy) onOpen()
      }}
    >
      {busy ? (
        <Spin size="small" />
      ) : (
        <ChatAttachmentIcon
          filename={attachment.filename}
          mimeType={attachment.mimeType}
          size={16}
          className={styles.attachmentIcon}
        />
      )}
      <Text
        ellipsis={{ tooltip: attachment.filename }}
        className={styles.attachmentName}
      >
        {attachment.filename}
      </Text>
      <Text type="secondary" className={styles.attachmentMeta}>
        {formatFileSize(attachment.sizeBytes)}
      </Text>
    </button>
  )
}
